<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="场次">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24"> 
            <a-form-item label="状态">
              <a-select v-model="queryParam.memberstatus" placeholder="请选择"
                        allowClear>
                <a-select-option value="1">完成联系人信息</a-select-option>
                <a-select-option value="2">完成人员信息</a-select-option> 
                <a-select-option value="6">报名成功</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> 


          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
           <a-button icon="download" @click="download(2)" >下载人员信息表</a-button>


      <a-upload
        name="file"
        accept=".xlsx"
        action
        :before-upload="beforeUpload"
        style="margin-left: 8px;display: inline-block"
      >
        <a-button>
          成绩导入
          <a-icon type="upload" />
        </a-button>
      </a-upload>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.name }}
            <br/>
            {{ record.saiji }} {{ record.saiqu }}
            <br/>
            <span style="color: #999">性别:{{ record.sex }} 联系电话:{{ record.phone }}</span>
            <br/>
            报名时间 {{ record.create_time | timeFormat }}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.memberstatus==6" color="green">报名成功</a-tag>
        <a-tag v-else-if="record.memberstatus==1">完成联系人信息</a-tag>
        <a-tag v-else-if="record.memberstatus==2">完成人员信息</a-tag>

      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
         <a-divider type="vertical"/>
          <a @click="handleScoreEdit(record)">设置成绩</a>
                   <a-divider type="vertical"/>
           <a-popconfirm title="确定删除吗?" @confirm="handleDelete(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
              >
                <a-input v-decorator="[
              'danwei',
              {rules: [{ required: true, message: '请输入单位' }]}
            ]"
                         placeholder="请输入单位"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
              >
                <a-input v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入名称' }]}
            ]"
                         placeholder="请输入名称"/>
              </a-form-item>
            </a-col>

          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="编号"
                  hasFeedback
              >
                <a-input v-decorator="[
              'code',
              {rules: [{ required: true, message: '请输入编号' }]}
            ]"
                         placeholder="请输入编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入联系人姓名' }]}
        ]"
                         placeholder="请输入联系人姓名"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="性别"
                  hasFeedback
              >
                <a-input v-decorator="[
          'sex',
          {rules: [{ required: true, message: '请输入性别' }]}
        ]"
                         placeholder="请输入性别"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机"
                  hasFeedback
              >
                <a-input v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入手机' }]}
        ]"
                         placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="邮箱"
                  hasFeedback
              >
                <a-input v-decorator="[
          'email',
          {rules: [{ required: true, message: '请输入邮箱' }]}
        ]"
                         placeholder="请输入邮箱"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="微信"
                  hasFeedback
              >
                <a-input v-decorator="[
          'weixin',
          {rules: [{ required: true, message: '请输入微信' }]}
        ]"
                         placeholder="请输入微信"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input v-decorator="[
          'num',
          {rules: [{ required: true, message: '请输入身份证' }]}
        ]"
                         placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  label="身份证照片"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
                <pic-uploader
                    :file-list="formData.pic"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="scoreVisible"
        @ok="handleScoreOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item  :labelCol="labelCol"
                            :wrapperCol="wrapperCol" label="项目">
                <a-select
                    showSearch
                    optionFilterProp="title"
                    v-model="formData.project"
                    placeholder="选择项目"
                    allowClear
                >
                  <a-select-option :key="option.id" v-for="option in projectOptions" :title="option" :value="option">{{option}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24" v-if="formData.project== '花球男' || formData.project== '花球女'">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="左右腿搬腿平衡控5秒"
                  hasFeedback
              >
                <a-input v-decorator="[
          'score_btph',
          {rules: []}
        ]"
                         placeholder="请输入左右腿搬腿平衡控5秒"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-else>
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="肋木举腿"
                  hasFeedback
              >
                <a-input v-decorator="[
          'score_lmjt',
          {rules: []}
        ]"
                         placeholder="请输入肋木举腿"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="60秒团身+屈体分腿跳"
                  hasFeedback
              >
                <a-input v-decorator="[
          'score_ts',
          {rules: []}
        ]"
                         placeholder="60秒团身+屈体分腿跳"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="60秒俯卧撑"
                  hasFeedback
              >
                <a-input v-decorator="[
          'score_fwc',
          {rules: []}
        ]"
                         placeholder="60秒俯卧撑"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="技术技巧"
                  hasFeedback
              >
                <a-input v-decorator="[
          'score_jsjq',
          {rules: []}
        ]"
                         placeholder="请输入技术技巧"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="60秒“两头起”"
                  hasFeedback
              >
                <a-input v-decorator="[
          'score_ltq',
          {rules: []}
        ]"
                         placeholder="请输入60秒“两头起”"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="总分"
                  hasFeedback
              >
                <a-input v-decorator="[
          'score_total',
          {rules: []}
        ]"
                         placeholder="请输入总分"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="scoreVisible = false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleScoreOk">保存</a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
  import setting from '@/config/setting'
  import qs from 'qs'
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import ContentPicker from '@/components/ContentPicker/'
import RSwitch from '@/components/RSwitch/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import 'moment/locale/zh-cn';
  import XLSX from 'xlsx'

moment.locale('zh-cn');

import {getApplyMemberList, 
  sjsqOptions,getApplyMemberDetail,scoreImport, editApplyMember, deleteApplyMember, editApplyMemberScore} from '@/api/nlcs'

export default {
  name: 'AbilityApplyMemberList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    ContentPicker,
    STable,
    RSwitch,
    EditableCell,
  },
  data() {
    return {
      areaOptions,
      visible: false,
      scoreVisible: false,
      sjsqOptions: [],
      documentVisible: false,
      saveLoading: false,
      settingVisible: false,
      shenbaoOptions: [
        {'label': '裁判等级（舞蹈）', 'value': 'caipandengjiwudao'}, {
          'label': '裁判等级（技巧）',
          'value': 'caipandengjijiqiao'
        }, {'label': '教练等级（舞蹈）', 'value': 'jiaoliandengjiwudao'}, {'label': '教练等级（技巧）', 'value': 'jiaoliandengjijiqiao'}
      ],
      gjsbOptions: [
        {'label': '高级裁判员资质申请', 'value': 'caipan'}, {'label': '高级教练员资质申请', 'value': 'jiaolian'}
      ],
      formData: {
        id: 0,
        name: '', num: '', code: '', danwei: '', sex: '', pic: [],
        phone: '', email: '', weixin: '', project: ''
      },
      huiyiFormData: {
        //station_id=271&content_id=33
        station_id: undefined,
        content_id: undefined,
      },
      saijiOptions: [],
      groupOptions: [],
      exameOptions: [],
      saiquOptions: [],
      typeOptions: [{
        name: '会议',
        id: 1,
      }, {
        name: '培训',
        id: 2,
      }, {
        name: '训练营',
        id: 3,
      }, {
        name: '论文科报会',
        id: 4,
      }],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      mdl: {},
      projectOptions: ['花球男', '花球女', '技巧男', '技巧女', '街舞男', '街舞女'],

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '名称',
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 162,
          scopedSlots: {customRender: 'action'},
        }
      ],

      //人员管理表头
      documentColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '标题',
          dataIndex: 'title',
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '类型',
          width: '100px',
          dataIndex: 'type',
          scopedSlots: {customRender: 'typename'},
          filters: [
            {
              text: '文件',
              value: '1'
            },
            {
              text: '导师',
              value: '2'
            },
          ],
          filterMultiple: false,
          onFilter: (value, record) => record.type == value,
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: {customRender: 'action'},
        }
      ],
      documentList: [],
      documentKeywords: '',
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getApplyMemberList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],

      //表头
      serviceTypeColumns: [
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '价格',
          width: '150px',
          dataIndex: 'price',
        },
        {
          title: '仅限本地',
          width: '150px',
          dataIndex: 'loc',
          scopedSlots: {customRender: 'loc'},
        },
        {
          title: '仅限本省',
          width: '150px',
          dataIndex: 'onlyprovince',
          scopedSlots: {customRender: 'onlyprovince'},
        },
        {
          title: '显示',
          dataIndex: 'show',
          width: '150px',
          scopedSlots: {customRender: 'show'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: {customRender: 'action'},
        },
      ],
      serviceTypeQuery: {
        saiqu: 0,
      },
      serviceTypeVisible: false,
      serviceTypeFormVisible: false,
      serviceTypeList: [],
      serviceTypeFormData: {
        id: 0,
        name: '',
        onlyprovince: 1,
        loc: 1,
        show: 1,
        onlybaos: [],
      },
      settingFormData: {
        gjsb_cp2_to_cp1: 0,
        gjsb_cp1_to_guojia: 0,
        gjsb_cpguojia_to_guoji: 0,
        gjsb_jl2_to_jl1: 0,
        gjsb_jlyi_to_gaoji: 0,
        gjsb_jlgao_to_guojia: 0,
      },
    }
  },
  computed: {},
  created() {
  },

  mounted() {
      let that = this;
      that.getSjsqOptions();
  },
  methods: {
    moment,
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then(res => {
        that.sjsqOptions = res.data;
      });
    },
    addHandle() {
      this.formData = {
        id: 0,
        name: '', num: '', code: '', danwei: '', sex: '', pic: [],
        phone: '', email: '', weixin: '', project: ''
      }
      this.form.resetFields();
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleServiceTypeCancel() {
      this.serviceTypeFormVisible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleEdit(record) {
      let self = this
      this.visible = true
      getApplyMemberDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.formData.id = record.id;
          console.log('handleEdit')
          if (res.data.area) {
            res.data.areas = [res.data.area.substring(0, 2) + '0000', res.data.area.substring(0, 4) + '00', res.data.area];
          } else {
            res.data.areas = [];
          }
          res.data.time_range_moment = [moment(res.data.stime * 1000), moment(res.data.etime * 1000)];

          self.formData = {...res.data};
        }, 200)
      })
      // console.log(this.mdl)
    },

    handleScoreEdit(record) {
      let self = this
      this.scoreVisible = true
      getApplyMemberDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form2.setFieldsValue({...res.data})
          self.formData.id = record.id;
          console.log('handleEdit')
          if (res.data.area) {
            res.data.areas = [res.data.area.substring(0, 2) + '0000', res.data.area.substring(0, 4) + '00', res.data.area];
          } else {
            res.data.areas = [];
          }
          res.data.time_range_moment = [moment(res.data.stime * 1000), moment(res.data.etime * 1000)];

          self.formData = {...res.data};
        }, 200)
      })
      // console.log(this.mdl)
    },

    handleDelete(record) {
      let self = this;
      deleteApplyMember({id: record.id}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      })
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    addExtraField() {
      if (this.formData.extra_field.length && this.formData.extra_field[this.formData.extra_field.length - 1].name == '') {
        return false;
      }
      this.formData.extra_field.push({'label': '', 'desc': '', 'required': true});
    },
    removeExtraField(k) {
      this.formData.extra_field.splice(k, 1);
    },
    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          if (self.formData.id > 0) {
            editApplyMember({
              id: self.formData.id,
              name: values.name,
              num: values.num,
              code: values.code,
              danwei: values.danwei,
              sex: values.sex,
              phone: values.phone,
              email: values.email,
              weixin: values.weixin,
              pic: self.formData.pic,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh()
              self.visible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },

    // 增改 处理
    handleScoreOk(e) {
      let self = this;
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          if (self.formData.id > 0) {
            editApplyMemberScore({
              id: self.formData.id,
              score_btph: values.score_btph,
              score_lmjt: values.score_lmjt,
              score_ts: values.score_ts,
              score_ltq: values.score_ltq,
              score_fwc: values.score_fwc,
              score_jsjq: values.score_jsjq,
              score_total: values.score_total,
              project: self.formData.project,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh()
              self.scoreVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },
    onAddServiceType() {
      this.serviceTypeFormData = {
        id: 0,
        name: '',
        onlyprovince: 1,
        loc: 1,
        onlybaos: [],
        show: 1,
      },
          this.form2.resetFields();
      this.serviceTypeFormVisible = true
    },
    onEditServiceType(record) {
      let self = this
      this.serviceTypeFormVisible = true
      getServiceTypeDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form2.setFieldsValue({...res.data})
          self.serviceTypeFormData.id = record.id;
          self.serviceTypeFormData = {...res.data};
          self.serviceTypeFormData.onlybaos = self.serviceTypeFormData.onlybaos.map(item => {
            return parseInt(item)
          });
        }, 200)
      })
    },
    deleteServiceType(record) {
      let self = this;
      serviceTypeDelete({id: record.id}).then(res => {
        self.fetchServiceTypeList();
      })
    },
    handleServiceType(record) {
      let self = this
      self.fetchServiceTypeList()
      self.serviceTypeQuery.saiqu = record.id;
      self.serviceTypeVisible = true
    },
    handleBaoming(record) {
      // console.log("handleBaoming", record)
      this.$router.push({
        name: 'HuiyiApplyList',
        query: {
          saiji: record.saiji,
          saiqu: record.id,
        }
      })
    },

    handleDocument(record) {
      let self = this
      self.huiyiFormData.station_id = record.id;
      self.getDocumentList();

      this.documentVisible = true
    },

    getDocumentList() {
      let self = this
      getHuiyiFileList({station_id: self.huiyiFormData.station_id}).then(res => {
        self.documentList = res.data
      })
    },

    addFile() {
      let self = this;
      if (!self.huiyiFormData.content_id) {
        self.$message.error('请选择文章');
        return;
      }
      if (!self.huiyiFormData.type) {
        self.$message.error('请选择类型');
        return;
      }
      addHuiyiFile(self.huiyiFormData).then(res => {
        self.getDocumentList();

        self.huiyiFormData.content_id = undefined;
        // self.huiyiFormData.station_id = undefined;

        self.$message.success('新增成功')
      }).catch(err => {
        self.$message.error(err.data.msg);
      })
    },
    deleteFile(record, index) {
      let self = this;
      deleteHuiyiFile({
        station_id: self.huiyiFormData.station_id,
        content_id: record.id,
      }).then(res => {
        self.$message.success('删除成功')
        self.documentList.splice(index, 1);
      }).catch(err => {
        self.$message.error(err.data.msg);
      })
    },


    fetchServiceTypeList() {
      let self = this
      getServiceTypeList(self.serviceTypeQuery).then(res => {
        self.serviceTypeList = res.data
      })
    },


    // 增改 处理
    handleServiceTypeOk(e) {
      let self = this;
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.serviceTypeFormData)
          self.saveLoading = true;
          if (self.serviceTypeFormData.id > 0) {
            editServiceType({
              id: self.serviceTypeFormData.id,
              name: values.name,
              price: values.price,
              note: values.note,
              loc: self.serviceTypeFormData.loc,
              onlyprovince: self.serviceTypeFormData.onlyprovince,
              show: self.serviceTypeFormData.show,
              onlybaos: self.serviceTypeFormData.onlybaos,
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchServiceTypeList();

              self.serviceTypeFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          } else {
            addServiceType({
              name: values.name,
              price: values.price,
              note: values.note,
              saiqu: self.serviceTypeQuery.saiqu,
              loc: self.serviceTypeFormData.loc,
              onlyprovince: self.serviceTypeFormData.onlyprovince,
              show: self.serviceTypeFormData.show,
              onlybaos: self.serviceTypeFormData.onlybaos,
            }).then(res => {
              self.$message.success('新增成功')
              self.fetchServiceTypeList();


              self.serviceTypeFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },


    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },


    onSetting() {
      let self = this
      this.settingVisible = true
      getSetting().then(res => {
        self.settingFormData = res.data;
        // console.log(this.mdl)
      })
    },


    // 增改 处理
    handleSettingOk(e) {
      let self = this;
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          self.saveLoading = true;
          setSetting(self.settingFormData).then(res => {
            self.$message.success('修改成功')
            self.settingVisible = false;
            self.saveLoading = false;
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
        }
      })
    },

    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },



      download(type){
        console.log('this.queryParam')
        console.log(this.queryParam)
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择场次');
          return ;
        }
        switch (type){ 
          case 2:
            window.open(setting.apiBaseURL+'/adminapi/ability/memberDownload?'+qs.stringify(this.queryParam));
            break; 

        }
      },


      beforeUpload(file) {
      let that = this
      let formdata = new FormData()
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata) 

      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log('this.xlsxJson',tabJson);
          // return ;
          let userList = [];
          tabJson[0].sheet.map((item,index) =>{
            if(item.身份证号){ 
              userList.push({
                id: item['人员ID'],
                score_ltq: item['60秒“两头起”']||0,
                score_ts: item['60秒团身+屈体分腿跳']||0,
                score_btph: item['左右腿搬腿平衡控5秒']||0,
                score_lmjt: item['肋木举腿']||0,
                score_fwc: item['60秒俯卧撑']||0,
                score_jsjq: item['技术技巧']||0,
                score_total: item['总分']||0, 
              });
            }

        })

        console.log('userList',userList);

            scoreImport({
              list: JSON.stringify(userList)
            }).then(res => {
              that.$message.success('导入成功') 
            }).catch(err => {
              that.$message.error(err.data.msg); 
            })

 

      }});
 
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },


    file2Xce(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader()
        reader.onload = function(e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file) // 传统input方法
      })
    },



  },
  filters: {},
  watch: {}
}
</script>
